import { Link } from "react-router-dom";
import { RotateCcw, Sparkles } from "lucide-react";

export const ReadingActions = ({ readingId, assistantTo, onReset, resetLabel, testid, children, onAssistant, showAssistant = true }) => (
  <div className="mt-6 pt-4 border-t border-amber-500/15 space-y-3" data-testid={`${testid}-actions`}>
    <div className="flex flex-wrap items-center justify-center gap-2" data-testid="result-actions-bar">
      {showAssistant && readingId && (
        <Link
          to={assistantTo}
          onClick={onAssistant}
          data-testid="result-assistant-btn"
          className="inline-flex items-center gap-1.5 px-3.5 py-1 text-[11px] rounded-full border border-amber-500/50 text-amber-200 hover:bg-amber-500/10 transition-colors"
        >
          <Sparkles className="w-3 h-3" /> Approfondisci con Arcana
        </Link>
      )}
      {children}
      <button
        onClick={onReset}
        data-testid={`${testid}-new-btn`}
        className="inline-flex items-center gap-1.5 px-3.5 py-1 text-[11px] rounded-full border border-amber-500/40 text-amber-200 hover:bg-amber-500/10 transition-colors"
      >
        <RotateCcw className="w-3 h-3" /> {resetLabel}
      </button>
    </div>
  </div>
);
